export default __webpack_public_path__ + "3d3429baecfaf3e941838e63e2a27871.png";